import { useAtomValue, useSetAtom } from 'jotai';

import { LeadsTableTab } from '@ekhodealer/ekho-common';
import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import type { ReactNode } from 'react';

import { FiltersDrawer } from '@common/components/FiltersDrawer';

import { useSearchLeads } from '../api/useSearchLeads';
import { allAppliedFiltersAtom } from '../atoms/leadsAppliedFiltersAtoms';
import { clearAllFiltersAtom, leadsParamsAtom } from '../atoms/leadsAtoms';

import {
	FiltersDrawerAccountSection,
	FiltersDrawerActionRequiredSection,
	FiltersDrawerDatesSection,
	FiltersDrawerDealAmountSection,
	FiltersDrawerPipelineSection,
	// CXP-2321: Pre-qual filter hidden until prequal is functional
	// FiltersDrawerPrequalSection,
	FiltersDrawerStageTypeSection,
	FiltersDrawerVehicleInterestsSection,
	LeadsFiltersDrawerAppliedFiltersSection,
} from './filters';

interface LeadsFiltersDrawerProps {
	trigger: ReactNode;
	viewMode?: 'table' | 'board';
	activeTab: LeadsTableTab;
}

export const LeadsFiltersDrawer = ({
	trigger,
	viewMode = 'table',
	activeTab,
}: LeadsFiltersDrawerProps) => {
	const allAppliedFilters = useAtomValue(allAppliedFiltersAtom);
	const clearAllFilters = useSetAtom(clearAllFiltersAtom);
	const hasAppliedFilters = allAppliedFilters.length > 0;

	const params = useAtomValue(leadsParamsAtom);
	const { data, isLoading } = useSearchLeads(params);
	const queryCount = data?.count ?? 0;

	return (
		<FiltersDrawer
			trigger={trigger}
			appliedFiltersSection={<LeadsFiltersDrawerAppliedFiltersSection />}
			filterSections={
				<>
					<FiltersDrawerActionRequiredSection />
					<Stack>
						{activeTab === LeadsTableTab.ALL && (
							<>
								<Divider />
								<FiltersDrawerPipelineSection />
							</>
						)}
						{/* CXP-2321: Pre-qual filter hidden until prequal is functional */}
						{/* <Divider /> */}
						{/* <FiltersDrawerPrequalSection /> */}
						<Divider />
						<FiltersDrawerStageTypeSection viewMode={viewMode} />
						<Divider />
						<FiltersDrawerVehicleInterestsSection />
						<Divider />
						<FiltersDrawerDealAmountSection />
						<Divider />
						<FiltersDrawerAccountSection />
						<Divider />
						<FiltersDrawerDatesSection />
					</Stack>
				</>
			}
			hasAppliedFilters={hasAppliedFilters}
			clearAllFilters={clearAllFilters}
			queryCount={queryCount}
			isLoading={isLoading}
			className='filters-drawer--custom'
		/>
	);
};
